import { useGameStore } from '@/store/gameStore';
import { trackEvent } from './events';

export function initAnalyticsSubscription(): void {
  useGameStore.subscribe((state, prevState) => {
    // Puzzle loaded (started)
    if (state.puzzle && state.puzzle !== prevState.puzzle && state.screen === 'game') {
      trackEvent({
        type: 'puzzle_start',
        puzzleId: state.puzzle.id,
        tier: state.puzzle.tier,
        category: state.puzzle.metadata.category,
      });
    }

    // Puzzle completed
    if (state.isComplete && !prevState.isComplete && state.puzzle) {
      const solveTime = Math.round((Date.now() - state.startTime) / 1000);
      trackEvent({
        type: 'puzzle_complete',
        puzzleId: state.puzzle.id,
        score: 0, // Score is computed in the component, not in store. Use 0 placeholder.
        strikes: state.strikesUsed,
        time: solveTime,
        stars: 0, // Same — computed elsewhere
        resets: state.resetsUsed,
        undoUsed: state.undoUsedThisPuzzle,
      });
    }

    // Hint used
    if (state.hintLevel > prevState.hintLevel && state.puzzle) {
      trackEvent({
        type: 'hint_used',
        puzzleId: state.puzzle.id,
        hintLevel: state.hintLevel,
      });
    }
  });
}
